module.exports = __webpack_public_path__ + "static/img/40008 (3).16041f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40008 (3).jpg
// module id = a+yF
// module chunks = 14